import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import CKEditor from 'ckeditor4-react';
import Loader from '../Loader/Loader';

class ViewQuestionSetup extends Component {
	
	constructor(props){
        super(props);
        MathJax.Hub.Config({
            tex2jax: {
                inlineMath: [['$', '$'], ['\\(', '\\)']],
                displayMath: [['$$', '$$'], ['\\[', '\\]']],
                jax: ["input/TeX", "input/MathML", "input/AsciiMath", "output/HTML-CSS", "output/NativeMML", "output/PreviewHTML"],
            },
            "HTML-CSS": {
                webFont: "TeX",
                automatic: false,
                matchFontHeight: true,
            },
            showMathMenu: false,
        });
		this.state = {
            data : [],
            questionid : this.props.id,
            lessons : this.props.lessons,
            lesson : '',
            loading : false
        }
    }

    componentDidMount(){
        this.getquestionsetup();
        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    }

    componentDidUpdate() {
        $("span.math-tex").closest("p").css("display", "inline");
        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    }
    
	getquestionsetup(){
		this.setState({loading : true});
		GetData('question/getquestionsetupbyid/'+this.props.id).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
                    data : responseJson,
                    acyear : responseJson[0].acyear,
                    cls : responseJson[0].class,
                    sub : responseJson[0].subject,
                    noofquestion : responseJson[0].noofquestions,
                    selection : responseJson[0].selection,
                    less : responseJson[0].lesson,
                    subname : responseJson[0].subjectname,
                    lesson : responseJson[0].lesson,
                    clsname : responseJson[0].clsname,
                    loading : false
                });
			}
		});
	}
    
    getLessonName(lesson){
        var d = this.state.lessons;
        console.log(d);
		var name= '';
		var ar = lesson.split(",");

		for(var i=0;i<ar.length;i++){
			d.filter(function(obj){
				if(obj.id == ar[i]){
					name+=obj.lesson+', ';
				}
			})
		}
		return name.replace(/,\s*$/, "");
	}

    render() {
    
        if (this.state.loading) {
			return (
				<Loader />
			)
		} else {
        return (<div>
            <Row>
                <Col md={12}>
                    <Table responsive>
                        <tbody>
                            <tr>
                                <td style={{border : '0px'}} align="left">Class : <b>{this.state.clsname}</b></td>
                                <td style={{border : '0px'}} align="right">Lesson : <b>{this.getLessonName(this.state.lesson)}</b></td>
                            </tr>
                            <tr>
                                <td style={{border : '0px'}} align="left">Subject : <b>{this.state.subname}</b></td>
                                <td style={{border : '0px'}} align="right">No.of Questions : <b>{this.state.data.length}/{this.state.noofquestion}</b></td>
                            </tr>
                        </tbody>
                    </Table><br />
                    <Table bordered responsive>
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Question</th>
                                <th>Option 1</th>
                                <th>Option 2</th>
                                <th>Option 3</th>
                                <th>Option 4</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data.map((item,i)=>
                                <tr>
                                    <td>{i+1}</td>
                                    <td><div dangerouslySetInnerHTML={{ __html: item.qusname }}></div></td>
                                    <td><div dangerouslySetInnerHTML={{ __html: item.option1 }}></div></td>
                                    <td><div dangerouslySetInnerHTML={{ __html: item.option2 }}></div></td>
                                    <td><div dangerouslySetInnerHTML={{ __html: item.option3 }}></div></td>
                                    <td><div dangerouslySetInnerHTML={{ __html: item.option4 }}></div></td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </div>)
        }
    }
}

export default ViewQuestionSetup;



// WEBPACK FOOTER //
// ./src/Questions/ViewQuestionSetup.js